module.exports = {"632523100":"河阴镇","632523101":"河西镇","632523102":"拉西瓦镇","632523103":"常牧镇","632523200":"河东乡","632523201":"新街回族乡","632523202":"尕让乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/632523.json
// module id = 3002
// module chunks = 0